<div class="container-modal-lateral filtro-disparo-modal">
  <div>
    <span class="title-modal-lateral">Filtrar</span>
    <div class="campos-filtro">
      <app-form-field
        class="width-100"
        label="Período da data de envio"
        heightFormField="36px"
        placeholder="Selecione o período"
        widthFormField="100%"
        [isDateRange]="true"
        [dataInicio]="filtro.dataEnvioInicio"
        (dataInicioChange)="filtro.dataEnvioInicio = $event"
        [dataFim]="filtro.dataEnvioFim"
        (dataFimChange)="filtro.dataEnvioFim = $event"
        backgroundColor="rgba(221, 188, 255, 0.1)">
      </app-form-field>

      <app-select-multiple
        class="width-100" label="Recorrência pai" campo="nome" heightFormField="36px"
        [listaInput]="programacoes" [itensSelecionado]="filtro.programacoes"
        (selecionarItem)="filtro.programacoes = $event" [carregandoInfo]="carregando">
      </app-select-multiple>

      <app-select-multiple
        class="width-100" label="Status" campo="nome" heightFormField="36px"
        [listaInput]="statusOpcoes" [itensSelecionado]="filtro.status"
        (selecionarItem)="selecionarStatus($event)">
      </app-select-multiple>

      <app-select-multiple
        class="width-100" label="Usuário" campo="nome" heightFormField="36px"
        [listaInput]="usuarios" [itensSelecionado]="filtro.usuarios"
        (selecionarItem)="filtro.usuarios = $event" [carregandoInfo]="carregando">
      </app-select-multiple>

      <app-select-multiple
        class="width-100" label="Setor" campo="nome" heightFormField="36px"
        [listaInput]="setores" [itensSelecionado]="filtro.setores"
        (selecionarItem)="filtro.setores = $event" [carregandoInfo]="carregando">
      </app-select-multiple>

      <app-select-multiple
        class="width-100" label="Número" campo="nome" subCampo="numero" heightFormField="36px"
        [listaInput]="contas" [itensSelecionado]="filtro.contas"
        (selecionarItem)="filtro.contas = $event" [carregandoInfo]="carregando">
      </app-select-multiple>

      <app-select-multiple
        class="width-100" label="Fluxo" campo="titulo" heightFormField="36px"
        [listaInput]="fluxos" [itensSelecionado]="filtro.fluxos"
        (selecionarItem)="filtro.fluxos = $event" [carregandoInfo]="carregando">
      </app-select-multiple>
    </div>
  </div>

  <div class="botoes-modal-lateral">
    <app-button-padrao width="100%" label="Filtrar" borderRadius="8px"
      backgroundColor="var(--verde-padrao)" color="white" (buttonClick)="salvar()">
    </app-button-padrao>
    <app-button-padrao width="100%" label="Cancelar" backgroundColor="white"
      color="var(--vermelho-padrao)" borderRadius="8px" borderColor="var(--vermelho-padrao)"
      borderStyle="solid" borderWidth="1px" (buttonClick)="cancelar()">
    </app-button-padrao>
  </div>
</div>
